module.exports = __webpack_public_path__ + "static/media/Karey Gauthier Headshot.b9aa6167.jpeg";